<template>
  <div class="">
    <!-- Título principal -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Retenciones
      </h1>
    </div>

    <!-- Layout en dos columnas sin v-row -->
    <div class="grid grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-8">
      <!-- Columna izquierda - Documentación -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Información del endpoint -->
        <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
          <h3 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            <span
              class="bg-green-100 text-green-800 px-2 py-1 rounded text-sm xl:text-base font-mono mr-3"
              >GET</span
            >
            <span class="text-xs xl:text-base">
              https://sb-wee.ar/v1/reporte/retenciones?Date=03-01-2023</span
            >
          </h3>
          <p class="text-gray-600 text-sm xl:text-base mb-2">
            Retorna todos las retenciones para el día especificado.
          </p>
        </div>

        <!-- Parámetros -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Request
        </h4>

        <!-- Headers Table -->
        <DynamicTable
          title="Headers"
          :headers="headersRetenciones"
          :data="headersData"
          height="auto"
        />

        <!-- Body Table -->
        <DynamicTable
          title="Path parameters"
          :headers="bodyHeaders"
          :data="bodyParameters"
          height="auto"
        />

        <!-- Response -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Response
        </h4>

        <DynamicTable
          title="Atributos del objeto de la respuesta."
          :headers="responseHeaders"
          :data="responseData"
          height="auto"
        />

        <DynamicTable
          title="Atributos del objeto data."
          :headers="responseHeadersObjet"
          :data="responseObjectData"
          height="150px"
        />
      </div>

      <!-- Columna derecha - Ejemplos de código -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Request Example -->

        <div class="bg-white rounded-lg border border-gray-200 p-3 xl:p-6">
          <h4 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            Headers
          </h4>
          <span class="text-black">
            <p>
              <code class="text-black">Content-Type: application/json</code>
            </p>
            <p>
              <code class="text-black"
                >Authorization: Bearer {{ apikeyExample }}</code
              >
            </p>
          </span>
        </div>

        <!-- Response Example -->
        <CodeBlock
          title="Example Response"
          :code="responseExample"
          language="json"
          status="info"
          :is-large="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DynamicTable from "../shared/DynamicTable.vue";
import CodeBlock from "../shared/CodeBlock.vue";

export default {
  name: "CrearSolicitudPago",
  components: {
    DynamicTable,
    CodeBlock,
  },
  data() {
    return {
      // Configuración de headers para la tabla de Headers
      headersRetenciones: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "pattern", label: "PATTERN" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de headers
      headersData: [
        {
          atributo: "Content-Type",
          tipo: "String",
          requerido: "Sí",
          pattern: "application/json",
          descripcion:
            "El tipo MIME del contenido del cuerpo enviado. Por defecto JSON es Unicode UTF-8. No se debe configurar otro charset.",
        },
        {
          atributo: "Authorization",
          tipo: "String",
          requerido: "Sí",
          pattern: "Bearer",
          descripcion: "ba7943e1-a60c-43e7-8812-xxxxxxxxxxxx",
        },
      ],

      // Configuración de headers para la tabla de Body
      bodyHeaders: [
        { key: "atributo", label: "ATRIBUTO", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de parámetros del body
      bodyParameters: [
        {
          atributo: "Date",
          tipo: "String",
          requerido: "Sí",
          descripcion:
            "Fecha de retenciones. Solo se puede pedir este reporte para una fecha anterior al día actual. Formato DD-MM-YYYY",
        },
      ],

      // Response
      responseHeaders: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseData: [
        {
          atributo: "cuenta_id",
          tipo: "Integer",
          descripcion:
            "Identificador de la cuenta de la que se realizó la retención.",
        },
        {
          atributo: "fecha_reporte",
          tipo: "DateTime",
          descripcion: "Fecha en la que se realizó la retención.",
        },
        {
          atributo: "total_retenido",
          tipo: "Integer",
          descripcion: "Total retenido en la cuenta.",
        },
        {
          atributo: "data",
          tipo: "Array[Object]",
          descripcion:
            "Arreglo de objetos con la información de cada retención.",
        },
      ],

      responseHeadersObjet: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseObjectData: [
        {
          atributo: "fecha_creacion",
          tipo: "DateTime",
          descripcion: "Fecha en la que se informo la retención",
        },
        {
          atributo: "pago_id",
          tipo: "Integer",
          descripcion: "Identificador del pago.",
        },
        {
          atributo: "referencia_externa",
          tipo: "String",
          descripcion:
            "Este atributo es utilizado como referencia para identificar la solicitud y sincronizar con tus sistemas de backend el origen de la operación.",
        },
        {
          atributo: "tipo",
          tipo: "String",
          descripcion: "Tipo de retención o percepción aplicada.",
        },
        {
          atributo: "canal_pago",
          tipo: "String",
          descripcion: "Nombre del medio de pago utilizado.",
        },
        {
          atributo: "monto",
          tipo: "Integer",
          descripcion: "Monto total del pago.",
        },
        {
          atributo: "alicuota",
          tipo: "Integer",
          descripcion: "Porcentaje de retención aplicada.",
        },
        {
          atributo: "importe_retenido",
          tipo: "Integer",
          descripcion: "Monto retenido.",
        },
      ],

      apikeyExample: " {{ apikey }}",

      responseExample: `{
        "cuenta_id": "000015",
        "fecha_reporte": "2023-11-07T00:00:00Z",
        "total_retenido": 135078,
        "data": [
            {
            "fecha_creacion": "2023-11-07T11:14:56Z",
            "pago_id": 49223,
            "referencia_externa": "1099578447",
            "tipo": "iibb",
            "canal_pago": "CREDIT",
            "monto": 179520,
            "alicuota": 2,
            "importe_retenido": 3590
            },
            {
            "fecha_creacion": "2023-11-07T11:14:56Z",
            "pago_id": 48910,
            "referencia_externa": "1099338355",
            "tipo": "iibb",
            "canal_pago": "CREDIT",
            "monto": 1214400,
            "alicuota": 2,
            "importe_retenido": 24288
            }
        ]
        }`,
    };
  },
};
</script>

<style scoped>
/* Responsive adjustments para el grid */
@media (max-width: 1279px) {
  .grid-cols-1.xl\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
</style>
